var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp, _initialiseProps;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { Button, Form, FormGroup, FormFeedback, Label, Input, InputGroup, InputGroupAddon, InputGroupText, CustomInput, Modal, ModalHeader, ModalBody, ModalFooter, Popover, PopoverHeader, PopoverBody } from 'reactstrap';
import { Card, CardTitle, CardText, CardBody, Row, Col, Container } from 'reactstrap';

import RXInput from './RXInput';

var logdown = require('logdown');
var logger = logdown('rx-forms-rx-input-list', { prefixColor: '#673ab7' });

var RXInputGroup = (_temp = _class = function (_Component) {
    _inherits(RXInputGroup, _Component);

    function RXInputGroup(props) {
        var _formData;

        _classCallCheck(this, RXInputGroup);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _initialiseProps.call(_this);

        logger.log('log in rxInputGroup with props: ' + JSON.stringify(props));
        var elementName = '' + _this.props.prefix + _this.props.group.name;
        var value = _this.props.formData && _this.props.formData[elementName] ? _this.props.formData[elementName] : _this.props.value;

        _this.state = {
            formData: (_formData = {}, _formData[elementName] = value, _formData),
            showPrependInfoOpen: false,
            showAppendInfoOpen: false,
            placeholders: _this.props.placeholders
        };
        logger.log('log rxInputGroup with state: ' + JSON.stringify(_this.state));
        return _this;
    }

    RXInputGroup.prototype.componentDidUpdate = function componentDidUpdate(prevState) {

        var elementName = '' + this.props.prefix + this.props.group.name;
        var value = this.props.formData && this.props.formData[elementName] ? this.props.formData[elementName] : this.props.value;
        if (this.props.formData != prevState.formData) {
            var _formData2;

            logger.log('12001: next data ' + elementName + ': ', this.props.formData);
            this.setState({ formData: (_formData2 = {}, _formData2[elementName] = value, _formData2) });
        }
    };

    RXInputGroup.prototype.render = function render() {
        var _this2 = this;

        var group = this.props.group;
        var hasAppendAddons = group.addons.append !== undefined;
        var hasPrependAddons = group.addons.prepend !== undefined;

        var prependOnClickWrapper = function prependOnClickWrapper(element) {
            return React.createElement(
                InputGroupText,
                null,
                element
            );
        };
        var prependButtonColor = "secondary";
        var prependButtonClick = function prependButtonClick(e) {};

        var appendOnClickWrapper = function appendOnClickWrapper(element) {
            return React.createElement(
                InputGroupText,
                null,
                element
            );
        };
        var appendButtonColor = "secondary";
        var appendButtonClick = function appendButtonClick(e) {};

        if (hasPrependAddons) {
            var prependIcon = group.addons.prepend.icon === undefined ? "fa-info" : group.addons.prepend.icon;
            var prependWidget = group.addons.prepend.icon === undefined ? React.createElement(
                'i',
                null,
                group.addons.prepend.text
            ) : React.createElement('i', { className: 'fa ' + prependIcon });
            prependButtonColor = group.addons.prepend.buttonColor ? group.addons.prepend.buttonColor : "secondary";

            //ADDED ONCLICK 
            if (group.addons.prepend.onClick && this.props.events[group.addons.prepend.onClick]) {
                prependButtonClick = function prependButtonClick(e) {
                    return _this2.props.events[group.addons.prepend.onClick](e);
                };
                console.debug('5401: in ADDONS with ', this.props.events);
                prependOnClickWrapper = function prependOnClickWrapper(element) {
                    return React.createElement(
                        Button,
                        { onClick: prependButtonClick, color: prependButtonColor },
                        element
                    );
                };
            }
        }

        if (hasAppendAddons) {
            // appendIcon = group.addons.append.icon === undefined ? "fa-info" : group.addons.append.icon 
            var appendIcon = group.addons.append.icon === undefined ? "fa-info" : group.addons.append.icon;
            appendButtonColor = group.addons.append.buttonColor ? group.addons.append.buttonColor : "secondary";

            var appendWidget = group.addons.append.icon === undefined ? React.createElement(
                'i',
                null,
                group.addons.append.text
            ) : React.createElement('i', { className: 'fa ' + appendIcon });

            //ADDED ONCLICK 
            if (group.addons.append.onClick && this.props.events[group.addons.append.onClick]) {
                appendButtonClick = function appendButtonClick(e) {
                    return _this2.props.events[group.addons.append.onClick](e);
                };
                console.debug('5401: in ADDONS with ', this.props.events);
                appendOnClickWrapper = function appendOnClickWrapper(element) {
                    return React.createElement(
                        Button,
                        { onClick: appendButtonClick, color: appendButtonColor },
                        element
                    );
                };
            }
        }

        var validators = group.validators === undefined ? [] : group.validators;
        var formvalidators = this.props.formvalidators;

        logger.log('with RXInputGroup prefix: ' + this.props.prefix);
        var elementName = '' + this.props.prefix + group.name;
        logger.log('after RXInputGroup elementName: ' + elementName);

        return React.createElement(
            InputGroup,
            null,
            hasPrependAddons && React.createElement(
                React.Fragment,
                null,
                React.createElement(
                    InputGroupAddon,
                    { id: group.name + '_addon_prepend', addonType: 'prepend', onMouseOver: this.showPrependInfo },
                    prependOnClickWrapper(prependWidget)
                ),
                group.addons.prepend.info !== undefined && React.createElement(
                    Popover,
                    { placement: group.addons.prepend.info.position, isOpen: this.state.showPrependInfoOpen, target: group.name + '_addon_prepend', toggle: this.hidePrependInfo },
                    React.createElement(
                        PopoverHeader,
                        null,
                        group.addons.prepend.info.title
                    ),
                    group.addons.prepend.info.placeholder === undefined ? React.createElement(
                        PopoverBody,
                        null,
                        group.addons.prepend.info.text
                    ) : React.createElement(
                        PopoverBody,
                        null,
                        this.returnPlaceholder(group.addons.prepend.info.placeholder)
                    )
                )
            ),
            React.createElement(RXInput, _extends({ type: group.type, ininputgroup: 1, value: this.state.formData[elementName], onChange: this.onChange, name: elementName, id: elementName, formvalidators: formvalidators, validators: validators, formstore: this.props.formstore, errors: this.props.errors, transformers: this.props.transformers }, group)),
            hasAppendAddons && React.createElement(
                React.Fragment,
                null,
                React.createElement(
                    InputGroupAddon,
                    { id: group.name + '_addon_append', addonType: 'append', onMouseOver: this.showAppendInfo },
                    appendOnClickWrapper(appendWidget)
                ),
                group.addons.append.info !== undefined && React.createElement(
                    Popover,
                    { placement: group.addons.append.info.position, isOpen: this.state.showAppendInfoOpen, target: group.name + '_addon_append', toggle: this.hideAppendInfo },
                    React.createElement(
                        PopoverHeader,
                        null,
                        group.addons.append.info.title
                    ),
                    group.addons.append.info.placeholder === undefined ? React.createElement(
                        PopoverBody,
                        null,
                        group.addons.append.info.text
                    ) : React.createElement(
                        PopoverBody,
                        null,
                        this.returnPlaceholder(group.addons.append.info.placeholder)
                    )
                )
            )
        );
    };

    return RXInputGroup;
}(Component), _initialiseProps = function _initialiseProps() {
    var _this3 = this;

    this.onChange = function (event) {

        var value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
        logger.log('in RXInputGroup onchange with event ' + value + ' and target: ' + event.target.id);

        var val = event.target.value;
        var id = event.target.id;

        _this3.setState(function (prevState) {
            logger.log('in setState for RXInputGroup with prev ' + prevState);
            var formData = prevState.formData;
            formData[id] = val;

            return { formData: formData };
        });

        logger.log('RXInputGroup log state: ' + JSON.stringify(_this3.state));
        _this3.props.parentOnChange(event);
    };

    this.returnPlaceholder = function (placeholder) {

        if (_this3.state.placeholders[placeholder] === undefined) {
            logger.log('in undefined for ' + _this3.state.placeholders[placeholder]);

            return _this3.state.placeholders[placeholder];
        } else {
            logger.log('in correct placeholder for ' + _this3.state.placeholders[placeholder]);

            return _this3.state.placeholders[placeholder];
        }
    };

    this.showPrependInfo = function () {
        _this3.setState({ showPrependInfoOpen: true });
    };

    this.hidePrependInfo = function () {
        _this3.setState({ showPrependInfoOpen: false });
    };

    this.showAppendInfo = function () {
        _this3.setState({ showAppendInfoOpen: true });
    };

    this.hideAppendInfo = function () {
        _this3.setState({ showAppendInfoOpen: false });
    };
}, _temp);


RXInputGroup.defaultProps = {
    prefix: "",
    value: "",
    events: {}
};
export default RXInputGroup;